import React from 'react';
import { useSignedUrl } from '@/hooks/useSignedUrl';
import { cn } from '@/lib/utils';

interface SignedVideoThumbnailProps {
  /** S3 key or absolute URL of the video */
  readonly src: string | null | undefined;
  readonly className?: string;
  readonly alt?: string;
}

/**
 * Displays the first frame of a video as a thumbnail.
 * Uses preload="metadata" to load only enough data to show frame 1.
 */
export function SignedVideoThumbnail({ src, className, alt }: SignedVideoThumbnailProps) {
  const resolvedUrl = useSignedUrl(src);

  if (!resolvedUrl) return null;

  return (
    <video
      src={`${resolvedUrl}#t=0.001`}
      preload="metadata"
      muted
      playsInline
      className={cn('pointer-events-none', className)}
      aria-label={alt ?? 'Video thumbnail'}
    />
  );
}
